import * as React from 'react';
import styles from './index.less';
import FModal from '@/components/FModal';
import { QRCode } from 'antd';
import { FUtil } from '@freelog/tools-lib';
import img_wechat from './wechat@2x.png';
import img_weixin from '@/assets/weixin.jpg';

interface WxShareConfigs {
  title: string;
  desc: string;
  imgUrl: string;
}

interface FWeiXinShareProps {
  configs: WxShareConfigs & {
    link: string;
  };

  onClose?: () => void;
}

/** 与 PC 二维码同一落地页（微信 JS 安全域名），用于卡片分享 */
export function buildWxSharePageUrl(configs: WxShareConfigs): string {
  return (
    'https://www.freelog.cn' +
    FUtil.LinkTo.wxShare({
      title: encodeURIComponent(configs.title),
      desc: encodeURIComponent((configs.desc || ' ').slice(0, 80)),
      link: encodeURIComponent(self.location.href),
      imgUrl: encodeURIComponent(configs.imgUrl),
    })
  );
}

function FWeiXinShare({ configs, onClose }: FWeiXinShareProps) {
  const [$isShowWechatShareModal, set$isShowWechatShareModal, get$isShowWechatShareModal] =
    FUtil.Hook.useGetState<boolean>(true);

  return (
    <FModal
      open={$isShowWechatShareModal}
      width={320}
      onCancel={() => {
        set$isShowWechatShareModal(false);
      }}
      centered={true}
      afterClose={() => {
        onClose?.();
      }}
    >
      <div style={{ height: 50 }} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
        <img src={img_wechat} style={{ width: 26 }} alt='' />
        <div
          style={{
            fontWeight: 400,
            fontSize: 16,
            color: '#222222',
            lineHeight: '22px',
          }}
        >
          扫码分享至微信
        </div>
      </div>
      <div style={{ height: 30 }} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <QRCode
          style={{ padding: 0, borderRadius: 0, border: 'none' }}
          value={buildWxSharePageUrl(configs)}
          // icon={img_weixin}
          bgColor={'#fff'}
          color={'#222'}
          size={220}
        />
      </div>
      <div style={{ height: 50 }} />
    </FModal>
  );
}

export default FWeiXinShare;
